var React = require('react');

function IconReportForecast (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M18,0A18,18,0,1,0,36,18,18,18,0,0,0,18,0Zm0,32.57A14.57,14.57,0,1,1,32.57,18,14.58,14.58,0,0,1,18,32.57ZM9,23l10-5L9,13ZM19,13V23l10-5Z"}));
}

IconReportForecast.defaultProps = {"viewBox":"0 0 36 36"};

module.exports = IconReportForecast;

IconReportForecast.default = IconReportForecast;
